import * as actionTypes from "./actionTypes";

export const  questionHandler = (data) => {

  return {
    type: actionTypes.QUESTION_HANDLER,
    value: data
  }
};
